import querystring from 'querystring'
import { mapGetters, mapMutations, mapActions } from 'vuex'

import { storage } from '@shared/utils/storage'
import Loadable from '@shared/mixins/loadable'
import Translatable from '@shared/mixins/translatable'
import { CleanableFormMixin } from '@shared/mixins/forms'

function isIn(list, value) {
  return list.indexOf(value) !== -1
}

export const isIE = (
  navigator.userAgent
  &&
  (
    Boolean(navigator.userAgent.match(/(MSIE)/i))
    ||
    Boolean(navigator.userAgent.match(/(Trident)/i))
    ||
    navigator.userAgent.indexOf("Edge") > -1
  )
)

function elementSelector(list, value, singular=false) {
  list = list.map(x => x)

  if (value === null) {
    // Null value has been set.
    // Remove all values except null.
    return [null]
  } else {
    // Non-null value has been set.
    // Remove null form all nulled lists.
    if (singular) {
      return [value]
    }

    if (isIn(list, null)) {
      list.splice(list.indexOf(null), 1)
    }

    if (isIn(list, value)) {
      list.splice(list.indexOf(value), 1)
    } else {
      list.push(value)
    }

    return list
  }
}

// FIXME: WERY FUCKING BAD!
let isReady = true

const HasStage = {
  computed: {
    ...mapGetters('user', ['isAuthenticated']),

    hasStage() {
      return this.$parent.$parent.stage && !!this.$parent.$parent.stage.order
    }
  }
}

const Test = {
  mixins: [HasStage],

  props: {
    questions: {
      type: Object,
      required: true
    }
  },

  data() { return {
    answers: this.initialAnswers()
  } },

  computed: {
    nutrilon() {
      return this.answers.nutrilon.length == 1
        ? (this.answers.nutrilon[0] || 1)
        : 1
    }
  },

  methods: {
    initialAnswers() {
      return {
        readyness: [],
        nutrilon: [],
        ate: [null],
      }
    },

    setAnswer(list, value) {
      this.answers[list] = elementSelector(
        this.answers[list], value, this.questions[list].singular
      )
    },

    hasAnswer(list, value) {
      return isIn(this.answers[list], value)
    },

    start() {
      this.answers = this.initialAnswers()
      this.$refs.test.open()
    },

    finish() {
      let options = {
        ate: [],
        select: 1,
        nutrilon: storage.getItem('#nutrilon') || this.nutrilon
      }
      let ate = this.answers.ate.map(x => x)

      dataLayer.push({
        'event': 'PopUp MiniTest Answers',
        'checkpoint': ['readyness', 'nutrilon', 'ate'].reduce((acc, x, index) => {
          return acc.concat(this.answers[x].map(val => {
            let title = this.questions[x].list.find(q => q.id == val)

            return `step${index + 1}: ${title ? title.title : 'null'}`
          }))
        }, [])
      })

      if (ate[0] !== null) {
        options.ate = ate

        for(let i = 1; i < 6; i++) {
          if (ate.indexOf(i) === -1) {
            options.select = i
            break
          }
        }
      }

      this.$refs.notReady.close()
      this.$refs.test.close()
      this.$emit('finish', options)
    },

    submit() {
      dataLayer.push({
        'event': 'PopUp MiniTest SendAnswers',
        'status': this.answers.readyness.length == 4 ? 'ready' : 'not ready'
      })

      if (this.answers.readyness.length == 4) {
        isReady = true
        this.finish()
        return
      }

      storage.setItem('#nutrilon', this.nutrilon)
      isReady = false
      this.finish(1)
      // this.$refs.notReady.open() // .then(x => this.finish())
      // this.answers = this.initialAnswers()
    },
  }
}


const OPERATORS = {
  ['==='](a, b) { return a === b },
  ['=='](a, b) { return a == b },
  ['!=='](a, b) { return a !== b },
  ['!='](a, b) { return a != b },

  ['<'](a, b) { return a < b },
  ['>'](a, b) { return a > b },
  ['<='](a, b) { return a <= b },
  ['>='](a, b) { return a >= b },
}

function hasGroup(stage, products) {
  return stage.required_product_group === null ? true
    : products.some(p => p.group == stage.required_product_group)
}

function matchedProducts(stage, selected, all=false) {
  return stage.all_products.filter(p => selected.has(p.id))
}

function hasEnough(stage, selected, operator='===', all=false) {
  let products = matchedProducts(stage, selected, all)
  let cmp = OPERATORS[operator]

  return cmp(
      stage.order == 5
        ? Math.min(stage.min_products, stage.products.length)
        : stage.min_products,
      products.length
    ) &&
    hasGroup(stage, products)
}

const values = x => {
  let v = []

  if (x.values) {
    try {
      x = x.values()
    } catch(e) {
      x = x ? x._values : []
    }
  }

  if (x) {
    for (var i = x.length - 1; i >= 0; i--) {
      v.push(x[i])
    }
  }

  return v
}

const unique = x => {
  let set = []

  for (let i of x) {
    if (set.indexOf(i) != -1) {
      set.push(i)
    }
  }

  return set
}

const Chooser = {
  mixins: [HasStage],
  inject: ['stagesService'],

  props: {
    groupDescs: { type: Object, required: true }
  },

  data() { return {
    stages: [],
    products: [],
    groups: [],
    goal: [],
    selected: [],
    used: new Set(),
    required: true,
    cmp: '==',
    all: false,

    texts: {},
  } },

  computed: {
    canProceed() {
      if (!this.required) return true

      return (
        this.selected.length > 0 &&
        this.goal.every(x => {
          return hasEnough(x, this.allSelected, this.cmp, this.all)
        })
      )
    },

    allSelected() {
      // FIXME: IE
      // if (!Array.isArray(this.selected)) {
      //   this.selected = [this.selected]
      // }

      return new Set(this.selected.concat(values(this.used)))
    },
  },

  methods: {
    clean() {
      this.stages = []
      this.products = []
      this.groups = []
      this.goal = []
      this.selected = []
      this.used = new Set()
      this.all = false

      this.texts = {}
      this.cmp = '=='
      this.resolve = x => {}
    },

    start(stages, texts={}, required=true, selected=[], useHistory=true, cmp='==', all=false) {
      this.clean()
      this.texts = texts
      this.cmp = cmp
      this.all = all
      this.required = required
      this.$refs.loader.open()
      this.stagesService.getStages().then(data => {
        this.stages = data
        this.$refs.loader.close()

        this.init(data.filter(x => stages.indexOf(x.order) !== -1), selected, useHistory)
      })

      return new Promise((resolve, reject) => {
        this.resolve = resolve
      })
    },

    p(stage) {
      return stage[this.all ? 'all_products' : 'products']
    },

    init(goal, selected=[], useHistory=true) {
      let is5 = goal.filter(x => x.order == 5).length > 0
      this.goal = goal
      this.selected = []
      let used = new Set()

      if (is5 || useHistory) {
        if (useHistory) {
          used = new Set(goal.reduce(
            (acc, x) => acc.concat(x.selected)
          , selected || []))
        } else {
          used = new Set(selected || [])
        }
      }
      if (!is5 && useHistory) {
        this.used = used
      }

      this.products = goal.reduce(
        (acc, x) => acc.concat(this.p(x))
      , []).filter(x => !used.has(x.id))

      this.texts.title = this.texts.title.format({
        count: goal.reduce(
          (acc, x) => acc + x.min_products - x.all_products.filter(x => this.used.has(x.id)).length
        , 0)
      })

      let ordered = this.products.sort((a, b) => {
        let group = (a.group || 0) - (b.group || 0)

        return group == 0
          ? a.order - b.order
          : group
      })

      let last
      let groups = []

      for (let item of ordered) {
        if (last !== item.group) {
          groups.push({ id: item.group, list: [] })
          last = item.group
        }

        if (groups.length && groups[groups.length - 1].list.findIndex(x => x.id == item.id) == -1) {
          groups[groups.length - 1].list.push(item)
        }
      }

      this.groups = groups

      this.$refs.chooser.open()
    },

    resolve() {},

    isSelected(value) {
      return isIn(this.selected, value)
    },

    select(value) {
      let selected = elementSelector(this.selected, value, false)

      if (selected.length > this.selected.length && this.canProceed && this.cmp == '==') return
      this.selected = selected
    },

    submit() {
      let stages = []
      let selected = new Set(this.selected)

      this.goal.forEach(x => {
        let products = this.p(x).map(p => p.id)
        stages.push({
          order: x.order,
          products: products.filter(p => selected.has(p)),
          used: products.filter(p => this.used.has(p)),
        })
      })

      this.$refs.chooser.close()
      this.resolve(stages.sort((a, b) => a.order - b.order))
    }
  }
}


const Selector = {
  mixins: [Translatable],
  data() { return {
    select: null
  } },

  methods: {
    start(texts={}) {
      this.$refs.modal.open()

      return new Promise((resolve, reject) => {
        this.resolve = resolve
      })
    },

    submit() {
      this.$refs.modal.close()

      if (this.$parent.$parent.stage.order >= this.select) {
        this.confirmOpen()
      } else {
        this.resolve(this.select)
      }
    },

    resolve() {},

    confirmOpen() {
      this.$refs.confirm.open()
    },

    confirmClose() {
      this.$refs.confirm.close()
    },

    confirmSucceed() {
      this.confirmClose()
      this.resolve(this.select)
    },
  }
}

import { masking } from '@shared/utils/helpers'
const Auth = {
  mixins: [CleanableFormMixin],

  props: {
    facebookUrl: {},
  },

  data() { return {
    texts: {},
    can: false
  } },

  created() {
    this.$on('submit-success', session => {
      this.$refs.modal.close()
      session.data.data.needReload = true
      this.resolve(session.data.data)
    })
  },
  mounted() {
  },
  methods: {
    ...mapActions({
      getSession: 'user/SESSION'
    }),
    start(texts={}) {
      this.$refs.modal.open()
      this.texts = texts
      setTimeout(() => {
        masking('phone', this)

      }, 1000)

      return new Promise((resolve, reject) => {
        this.resolve = resolve
      })
    },

    facebookAuth() {
      if (isIE) {
        window.location.assign(this.facebookUrl)
        return
      }

      let authWindow = window.open(
        this.facebookUrl,
        'authWindow',
          'height=450, width=550, top='
          + ($(window).height() / 2 - 275)
          + ', left='
          + ($(window).width() / 2 - 225)
          + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0'
      )

      let receiver = (...attrs) => {
        let host = ''
        try { host = authWindow.location.host } catch(e) {}
        if (host == window.location.host) {
          this.getSession()
            .then(session => {
              this.$refs.modal.close()

              this.resolve(session)
            })
          authWindow.close()

          return
        }

        setTimeout(receiver, 100)
      }

      receiver()
    },

    resolve() {},
  }
}

export default {
  template: '#calendar-stage-selector',

  inject: ['preloaderService', 'stagesService', 'productsService'],
  mixins: [Loadable],

  props: {
    texts: {
      type: Object,
      required: true
    }
  },

  data() { return {
    initialized: false,
    empty: false
  } },

  components: {
    Test,
    Chooser,
    Auth,
    Selector,
  },

  computed: {
    ...mapGetters('user', ['isAuthenticated']),
  },

  mounted() {
    if (this.preloaderService.isLoading) {
      this.preloaderService.$on('preloadingFinished', e => this.init())
    } else {
      this.init()
    }
  },

  watch: {
    isAuthenticated(nval, oval) {
      if (nval == true && oval == false && this.initialized == false) {
        this.init()
      }
    }
  },

  methods: {
    ...mapMutations('user', {
      'setSession': 'SET'
    }),

    init() {
      if (this.isAuthenticated) {
        this.setLoading()
        this.$nextTick(x => {
          this.stagesService.getStages().then(stages => {
            this.unsetLoading()
            let empty = stages.every(x => x.status == 'empty')
            this.empty = empty

            if (empty) {
              this.test()
            }
          })
        })
      }

      let query = querystring.parse(window.location.search.substr(1))

      if (!this.isAuthenticated && typeof query.select !== 'undefined') {
        this.test()
      }
    },

    test() {
      this.$refs.test.start()
    },

    initiator(init, step, select, {
      required=false,
      useHistory=true,
      nutrilon=1,
      selected=[]
    }) {
      let steps = this.isAuthenticated ? step : step + 1
      let empty = this.empty

      return this.$refs.chooser.start([select], {
        subtitle: steps == step
          ? false
          : this.texts.stepTitle.format({ step, steps }),

        title: this.texts.choose.title.format({
          stage: select
        }),
        description: isReady ? this.texts.resultReady : this.texts.resultNotReady
        // title: this.texts.choose.subtitle,
        // description: this.texts.choose.description.format({
        //   stage: select
        // })
      }, true, selected, useHistory)
        .then(data => {
          // Authenticates user
          init.stage = data.pop()

          if (nutrilon) {
            storage.setItem('#nutrilon', nutrilon)
          }
          if (!this.isAuthenticated) {
            return this.$refs.auth.start({
              title: this.texts.stepTitle.format({ step: steps, steps })
            })
          }
        })
        .then(user => {
          // Checking whether user needs new calendar, or he want's to
          // go back to an old one.
          if (!(user && user.id)) {
            return user
          }

          this.$refs.loader.open()

          return new Promise((resolve, reject) => {
            this.stagesService.getCurrent(false).then(({ current }) => {
              this.$refs.loader.close()
              if (typeof current === 'undefined') {
                resolve(user)
                return
              }

              this.$refs.confirmNew.open().then(x => {
                this.$refs.confirmNew.opened = false
                resolve(user)
              }).catch(x => {
                // If user desides to left the old calendar reloads
                // current stage.
                this.$refs.confirmNew.opened = false

                if (user && user.id) {
                  if (typeof nutrilon != 'undefined') user.nutrilon = nutrilon
                  this.setSession(user)
                }

                this.$refs.loader.close()
                this.$emit('ready', current)
                this.productsService.updateReactions()

                reject()
              })
            }).catch(x => resolve(user))
          })
        })
        .then(user => {
          this.$refs.loader.open()
          let config = { stage: init.stage, stages: init.ate }
          if (typeof nutrilon != 'undefined') config.nutrilon = nutrilon

          // Sends an info about the calendar that user have been
          // created to a google analitics.
          this.stagesService.getStages()
            .then(stages => {
              let groups = this.$refs.chooser.groupDescs
              let pStr = (product, order, step) => {
                product = stages
                .find(x => x.order == order)
                .all_products
                .find(x => x.id == product)

                return `step${step}-${groups[product.group].name}: ${product.name}`
              }

              if (this.empty || (user && user.id)) {
                dataLayer.push({
                  'event': 'PopUp Create Calendar',
                  'products': init.ate
                  .reduce((acc, x) => {
                    return acc.concat(x.products.map(p => pStr(p, x.order, 1)))
                  }, [])
                  .concat(
                    init.stage.products.map(x => pStr(x, init.stage.order, 2))
                  )
                })
              }
            })

          return this.stagesService.initializeStage(config)
            .then(stage => {
              // After stage initializetion sends ready request and
              // reloads current stage.
              if (user.needReload == true) {
                window.location.reload()
              }
              if (user && user.id) {
                if (typeof nutrilon != 'undefined') user.nutrilon = nutrilon
                this.setSession(user)
              }

              this.$refs.loader.close()
              this.$emit('ready', stage)
              this.productsService.updateReactions()

              if (empty) this.$refs.help.open()
              this.empty = false
            })
        })
    },

    choose({ ate, select, nutrilon }, required = false, useHistory = true) {
      //
      // BE CAREFUL, STRANGER!
      //
      // COPY PASTED!
      //

      if (typeof select === 'undefined') {
        throw new Error('You should provide stage to select.')
      }

      let init = { ate: [], stage: {} }
      this.stagesService.stages_list = {}

      if (typeof ate !== 'undefined' && ate.length > 0) {
        this.$refs.chooser.start(ate, {
          subtitle: this.texts.stepTitle.format({
            step: 1,
            steps: this.isAuthenticated ? 2 : 3
          }),
          title: this.texts.chooseAte.title.format({
            stage: select
          }),
          description: isReady ? this.texts.resultReady : this.texts.resultNotReady
          // description: this.texts.chooseAte.description
        }, required && ate.length < 1, [], useHistory, '<=', true)
          .then(data => {
            this.stagesService.getStages()
              .then(stages => {
                if (!required) {
                  let first = data[0].order
                  let full = data.filter(stage => {
                    let products = stage.products.concat(stage.used)
                    return products.length >= stages.find(x => x.order == stage.order).min_products
                  }).map(x => x.order)

                  if (full.length > 0) {
                    if (full[0] != first) {
                      select = first
                    } else {
                      let prev = first

                      for (let x of full) {
                        if (x - prev > 1) {
                          select = prev
                          break
                        }

                        prev = x
                      }
                    }
                  } else {
                    select = first
                  }
                }

                init.ate = data.filter(x => x.order != select)
                let selected = Array.prototype.concat.apply(
                  [], data.map(x => x.products.concat(x.used))
                )
                // data.filter(x => x.order == select)
                // let products = selected.length > 0
                //   ? selected[0].products.concat(selected[0].products)
                //   : []

                this.initiator(init, 2, select, {
                  selected, required, useHistory, nutrilon
                })
              })
          })
      } else {
        this.initiator(init, 1, select, {
          required, useHistory, nutrilon
        })
      }
    },

    chooseTest({ ate, select, nutrilon }, required=false, useHistory=true) {
      //
      // BE CAREFUL, STRANGER!
      //
      // COPY PASTED!
      //

      if (typeof select === 'undefined') {
        throw new Error('You should provide stage to select.')
      }

      let init = { ate: [], stage: {} }
      this.stagesService.stages_list = {}

      if (typeof ate !== 'undefined' && ate.length > 0) {
        this.$refs.chooser.start(ate, {
          subtitle: this.texts.stepTitle.format({
            step: 1,
            steps: this.isAuthenticated ? 2 : 3
          }),
          title: this.texts.chooseAte.title.format({
            stage: select
          }),
          description: isReady ? this.texts.resultReady : this.texts.resultNotReady
          // description: this.texts.chooseAte.description
        }, false, [], useHistory, '<=', true)
          .then(data => {
            let map = {}
            data.forEach(stage => {
              map[stage.order] = stage.products.length
            })
            let has = (...stages) => stages.reduce(
              (acc, x) => acc && (map[x] || 0) > 0, true
            )

            // Table
            if (has(1, 2, 3, 4) || has(1, 2, 4) || has(1, 3, 4) || has(1, 4) || has(2, 4)) {
              select = 5
            } else if (has(1, 2, 3) || has(2, 3)) {
              select = 4
            } else if (has(1, 2)) {
              select = 3
            } else if (has(1, 3) || has(1) || has(3)) {
              select = 2
            } else {
              select = 1
            }

            init.ate = data.filter(x => x.order != select)
            let selected = Array.prototype.concat.apply(
              [], data.map(x => x.products.concat(x.used))
            )

            this.initiator(init, 2, select, {
              selected, required, useHistory, nutrilon
            })
          })
      } else {
        this.initiator(init, 1, select, {
          required, useHistory, nutrilon
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/calendar/components/stage-selector.js